module.exports = __webpack_public_path__ + "static/media/about_description_image.c367b3e2.webp";